/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Editor_ReadonlyInputs */

const en_statement_taxonomy_editor_readonly = /** @type {(inputs: Statement_Taxonomy_Editor_ReadonlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The default classification template cannot be edited. Duplicate it to make your own.`)
};

const nl_statement_taxonomy_editor_readonly = /** @type {(inputs: Statement_Taxonomy_Editor_ReadonlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het standaardclassificatiesjabloon kan niet worden bewerkt. Dupliceer het om een eigen versie te maken.`)
};

/**
* | output |
* | --- |
* | "The default classification template cannot be edited. Duplicate it to make your own." |
*
* @param {Statement_Taxonomy_Editor_ReadonlyInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_editor_readonly = /** @type {((inputs?: Statement_Taxonomy_Editor_ReadonlyInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Editor_ReadonlyInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_editor_readonly(inputs)
	return en_statement_taxonomy_editor_readonly(inputs)
});